import { Modal, Box } from '@mui/material';
import Login from '../pages/login';
import { Z_INDEX } from '../styles/zIndex';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const LoginModal = ({ open, setOpen }: Props) => {

  const handleClose = (_event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return; // ← do nothing
    }
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={true}
      aria-labelledby="login-modal-title"
      aria-describedby="login-modal-description"
      closeAfterTransition
      sx={{
        zIndex: Z_INDEX.loginModal,
        backdropFilter: 'blur(4px)', // Optional: soft blur behind
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark semi-transparent overlay
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 440 },
          maxWidth: 440,
          maxHeight: '90vh',
          bgcolor: 'transparent',
          boxShadow: 'none',
          p: 0,
          outline: 'none',
          borderRadius: 2,
          overflowY: 'auto',
          msOverflowStyle: 'none', // IE/Edge
          scrollbarWidth: 'none', // Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome/Safari
          },
        }}
      >
        <Login isModal={open} setIsModal={setOpen} />
      </Box>
    </Modal>
  );
};

export default LoginModal;